import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import Lottie from 'react-lottie-player';
import { HeadingText50, BodyTextMedium } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';

import successAnimation from 'src/public/animations/success.json';

interface Props {
    title: string;
    subtitle?: string | undefined | null;
    onRedirect: () => void;
    redirectDelay?: number;
}

export function ReviewSubmissionSuccess({
    title,
    subtitle,
    onRedirect,
    redirectDelay = 3000,
}: Props) {
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            onRedirect();
        }, redirectDelay);

        return () => clearTimeout(timeoutId);
    }, [onRedirect, redirectDelay]);

    return (
        <Container>
            <SuccessAnimation animationData={successAnimation} loop={false} speed={0.6} play />
            <HeadingText50 marginTop={25} centered fontColor="white">
                {title}
            </HeadingText50>
            {!!subtitle && (
                <BodyTextMedium marginTop={20} centered fontColor="white">
                    {subtitle}
                </BodyTextMedium>
            )}
        </Container>
    );
}

const Container = styled.div({
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: 70,
    paddingBottom: 100,
    backgroundColor: colors.blue75,
});

const SuccessAnimation = styled(Lottie)({
    width: 150,
    height: 150,
});
